import React,{ useEffect, useState } from 'react';
import Amount from '../options/Amount';
const Drink_Options = ( { handleAdd, handleSubtract, formValues } ) => {
  return (
    <>
    <br/>
    <br/>
    <br/>
    <br/>
    <br/>
    <br/>
    <br/>
    <br/>
    <br/>
    <br/>
    <Amount handleAdd={ handleAdd } handleSubtract={ handleSubtract } formValues = { formValues }/>
    </>
  );
};

export default Drink_Options;
